import type { GetAccessTokenResponse } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderNoAuth/models';
import { Store } from 'redux';

import { selectRefreshToken } from '@bolteu/redux-session';
import { updateAccessTokenAsync } from '@bolteu/redux-session/build/src/actions';

import { ApiClient } from '../api';

export class SessionService {
  constructor(private globalReduxStore: Store, private apiClient: ApiClient) {}

  public async updateAccessToken(
    updateAccessTokenPayload: boolean = true,
  ): Promise<GetAccessTokenResponse> {
    const reduxState = this.globalReduxStore.getState();
    const refreshToken = reduxState ? selectRefreshToken(reduxState) : null;

    const accessTokenResponse = await this.apiClient.session.publicGetAccessToken({
      refresh_token: refreshToken,
      update_access_token_payload: updateAccessTokenPayload,
    });

    this.globalReduxStore.dispatch(
      updateAccessTokenAsync.success({ accessToken: accessTokenResponse.access_token }),
    );
    return accessTokenResponse;
  }
}
